import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, Popup } from 'semantic-ui-react';

type EditReviewButtonProps = {
  reviewId: number;
  disabled?: boolean;
  page?: number;
};

export const EditReviewButton: FunctionComponent<EditReviewButtonProps> = ({
  reviewId,
  disabled = false,
  page,
}) => {
  const navigate = useNavigate();

  return (
    <Popup
      content="Editer"
      position="top center"
      trigger={
        <Button
          basic
          primary
          icon
          disabled={disabled}
          onClick={(): void => {
            navigate({
              pathname: `/reviews/update/${reviewId}`,
              search: page !== undefined ? `?page=${page}` : undefined,
            });
          }}
        >
          <Icon name="pencil" />
        </Button>
      }
    />
  );
};
